<script>
/**
 * Features component
 */
export default {
  name: 'Features'
};
</script>
<style scoped>
.black-text
{
  color: black !important;
}
</style>
<template>
  <!--START FEATURES-->
  <section class="section" id="features">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-5 order-2 order-lg-1">
          <div class="features-box mt-5 mt-lg-0">
            <h3>Добре дошли във FANMATH!</h3>
            <div >
            <p
              class="text-muted web-desc black-text"
            >Заповядайте в един по-нетрадиционен курс по математика! <br><br> Обучението е предвидено за деца от 6-ти и 7-ми клас.<br><br><br><br>
            В часовете учениците откриват вълшебствата в чудния свят на математиката като:</p>
            <ul class="text-muted list-unstyled margin-t-30 features-item-list black-text">
              <li class>Отработват теми от училищното учебно съдържание</li>
              <li class>Запознават се с различни типове логически задачи, неизучавани в училище, и стратегии за решаването им. 
                (решаване на тестове за проверка на коефициента за интелигентност-IQ), закономерности на числова редица, задачи от типа"лъжа-истина",
                 принцип на Дирихле, принцип на инварианта, задачи с преброявания , задачи, които се решават с таблици,
                  кръгове на Ойлер и др.)</li>
              <li class>Придобиват представа за изпитите в редица, чуждестранни училища и колежи - Американски, европейски, IT училища и академии.</li>
              <li>Разсъждават математически, когато се сблъскват със ситуации и проблеми, представени в контекста на реалния свят.</li>
              <li>Решават авторски пробни изпити и задачи </li>
              <br><br>
              Провежданото обучение в този курс е с доказано успешни постижения. <br><br>
              Доверието в обучението ученик-учител е предпоставка за постигане на отлични резултати от децата. <br><br>
              Обучението е в синхрон и е съобразно най-новите и актуални тенденции, програми и изпити.
            </ul>
          </div>
            <!-- <a href="#services" class="btn btn-custom margin-t-30"
              v-scroll-to="{ el:'#services', offset: -85}"
              data-scroll-spy-id="services">
              Научи повече
              <i class="mdi mdi-arrow-right"></i>
            </a> -->
          </div>
        </div>
        <div class="col-lg-7 order-1 order-lg-2">
          <div class="features-img mx-auto mr-lg-0">
            <img src="@/assets/images/fanmath-images/kid_studying.svg" alt="macbook image" class="img-fluid" />
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--END FEATURES-->
</template>